import { adminLinks } from "@vendata/power-up-links";
import type { Organization } from "@vendata/power-up-spec/schemas/Organization";

export type RepairStatusFilter = "open" | "closed";

/** Formats an ISO timestamp for display in the repairs table. */
export function formatCreatedAt(iso: string): string {
  return new Date(iso).toLocaleString();
}

/** Status filter from the route query (`?status=open` / `closed`). */
export function statusFromQuery(query: {
  status?: unknown;
}): RepairStatusFilter | undefined {
  if (query.status === "open" || query.status === "closed") {
    return query.status;
  }
  return undefined;
}

/** Query object for the status filter (empty when showing all). */
export function statusQuery(
  value: RepairStatusFilter | null,
): { status: RepairStatusFilter } | Record<string, never> {
  return value ? { status: value } : {};
}

/** Display label for an organization id from sibling list data. */
export function organizationLabel(
  organizations: Organization[],
  orgId: string,
): string {
  return organizations.find((org) => org.id === orgId)?.name ?? orgId;
}

/** Path to the repair detail page. */
export function repairDetailPath(id: string): string {
  return adminLinks.repairDetail.path.replace(":id", id);
}
